import * as $ from "jquery";
import * as AspNetData from "devextreme-aspnet-data";

import OidcManager from "./oidcManager";

export interface SearchResultItem
{
    id : number;
    index : number;
    path : number;
    text : number;
}

export default abstract class Api {

    private readonly address: string;
    
    protected constructor(private oidc: OidcManager, address: string) {
        this.address = address;
    }

    private beforeSendHandler(jqXHR: JQueryXHR) {
        jqXHR.setRequestHeader ("Authorization", "Bearer " + this.oidc.user!.access_token);
    }

    protected put<TRequest, TResponse>(path: string, request: TRequest ): JQueryPromise<TResponse> {
        let self = this;
        
        let dfd = $.Deferred<TResponse>();
        
        this.oidc.check().then(() => {
            $.ajax({
                url: this.address + path,
                type: "PUT",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(request),
                beforeSend: this.beforeSendHandler.bind(self),
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                dfd.reject(jqXHR)
            });
        });
        
        return dfd.promise();
    }
    
    protected post<TRequest, TResponse>(path: string, request: TRequest ): JQueryPromise<TResponse> {
        let self = this;
        
        let dfd = $.Deferred<TResponse>();

        this.oidc.check().then(() => {
            $.ajax({
                url: this.address + path,
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(request),
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                dfd.reject(jqXHR)
            });
        });

        return dfd.promise();
    }

    protected postForm<TRequest, TResponse>(path: string, formData: FormData): JQueryPromise<TResponse> {
        let self = this;

        let dfd = $.Deferred<TResponse>();

        this.oidc.check().then(() => {
            $.ajax({
                url: this.address + path,
                type: "POST",
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                dfd.reject(jqXHR)
            });
        });

        return dfd.promise();
    }

    protected get<TRequest, TResponse>(path: string, request: TRequest ): JQueryPromise<TResponse> {
        let self = this;

        let dfd = $.Deferred<TResponse>();

        this.oidc.check().then(() => {
            // console.log("API: get", path, request);
            $.ajax({
                url: this.address + path,
                type: "GET",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: request,
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                dfd.reject(jqXHR)
            });

        });

        return dfd.promise();
    }
    
    protected postBlob<TRequest>(path: string, request: TRequest ): JQueryPromise<any> {
        let self = this;

        let dfd = $.Deferred<any>();

        this.oidc.check().then(() => {

            $.ajax({
                url: this.address + path,
                type: "POST",
                xhrFields: {
                    responseType: 'blob'
                },
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(request),
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, (jqXHR,textStatus, errorThrown) => {
                dfd.reject(jqXHR)
            });

        });

        return dfd.promise();
    }
    
    protected getBlob<TRequest>(path: string, request: TRequest ): JQueryPromise<any> {
        let self = this;

        let dfd = $.Deferred<any>();

        this.oidc.check().then(() => {

            $.ajax({
                url: this.address + path,
                type: "GET",
                xhrFields: {
                    responseType: 'blob'
                },
                data: request,
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                
                jqXHR.then((data) => {
                    dfd.resolve(jqXHR)

                }, jqXHR1 => {
                    
                });
            });

        });

        return dfd.promise();
    }

    protected delete<TRequest, TResponse>(path: string, request: TRequest ): JQueryPromise<TResponse> {
        let self = this;
        
        let dfd = $.Deferred<TResponse>();

        this.oidc.check().then(() => {
            $.ajax({
                url: this.address + path,
                type: "DELETE",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(request),
                beforeSend: this.beforeSendHandler.bind(self)
            }).then(data => {
                dfd.resolve(data);
            }, jqXHR => {
                dfd.reject(jqXHR)
            });
        });

        return dfd.promise();
    }

    public createDataSource(path: string, onBeforeSend?: (operation: string, ajaxSettings: JQueryAjaxSettings) => void)  : DevExpress.data.DataSource {
        let self = this;

        return new DevExpress.data.DataSource(<DevExpress.data.DataSourceOptions>{
            store: AspNetData.createStore({
                key: "id",
                loadUrl: this.address + path,
                onBeforeSend: (operation, ajaxSettings) => {
                    ajaxSettings.beforeSend = this.beforeSendHandler.bind(self);

                    if(onBeforeSend)
                        onBeforeSend(operation, ajaxSettings);
                }
            })
        });
    }

    public createDataStore(path: string, onBeforeSend?: (operation: string, ajaxSettings: JQueryAjaxSettings) => void)  : DevExpress.data.CustomStore {
        let self = this;

        this.oidc.check().then(() => {
            
        });
        
        return AspNetData.createStore({
            key: "id",
            loadUrl: this.address + path,
            onBeforeSend: (operation, ajaxSettings) => {
                ajaxSettings.beforeSend = this.beforeSendHandler.bind(self);

                if (onBeforeSend)
                    onBeforeSend(operation, ajaxSettings);
            }
        });
    }
    
    protected filterByKey(keyExpr: any, keyValue: any, ) {
        if(!Array.isArray(keyExpr))
            return [keyExpr, keyValue];

        return keyExpr.map(function(i) {
            return [i, keyValue[i]];
        });
    }

    protected loadOptionsToActionParams(options: any, isCountQuery: any) {
        let result : any = {};

        if (isCountQuery)
            result.isCountQuery = isCountQuery;

        if (options) {

            ["skip", "take", "requireTotalCount", "requireGroupCount"].forEach(function (i) {
                if (i in options)
                    result[i] = options[i];
            });

            let filter = options.filter,
                select = options.select,
                userData = options.userData;

            if(userData) {
                for (let prop in userData) {
                    if(userData.hasOwnProperty(prop))
                        result[prop] = userData[prop];
                }
            }

            if (Array.isArray(filter)) {
                filter = $.extend(true, [], filter);
                result.filter = JSON.stringify(filter);
            }

            if (options.totalSummary)
                result.totalSummary = JSON.stringify(options.totalSummary);

            if (options.groupSummary)
                result.groupSummary = JSON.stringify(options.groupSummary);

            if (select) {
                if (!Array.isArray(select))
                    select = [select];
                result.select = JSON.stringify(select);
            }
        }

        return result;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/api.ts